import { ToDateTimeText } from "../../../utils/date";
import Box from "@material-ui/core/Box";
import PageviewIcon from '@material-ui/icons/Pageview';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';

export const getHistoryColumns = (exportData, ViewDetail) => {
  const columns = [
    {
      dataField: "DID",
      text: "",
      formatter: (cell, row) => {
        return (
          <Box component="div" display="flex" justifyContent="center">
            <PageviewIcon
              color="action"
              onClick={() => {
                ViewDetail(row.ID);
              }}
            />
            {(row.EXPORT_STATUS === "SUCCESS" && row.ISDOWNLOAD === 1) ? (
              <CloudDownloadIcon
                color="action"
                onClick={() => {
                  exportData(row.ID);
                }}
              />) : ""}
            
          </Box>
        );
      },
    },
    {
      dataField: "EXPORT_ID",
      text: "Export ID",
      sort: true,
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: "EXPORT_STATUS",
      text: "Status",
      formatter: (cell, row) => {
        return <>{(row.EXPORT_STATUS === "SUCCESS" || row.EXPORT_STATUS === "ERROR") ? row.EXPORT_STATUS : "Running"}</>;
      },
      sort: true,
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: "ERROR_MESSAGE",
      text: "Error Message",
      sort: true,
      formatter: (cell, row, rowIndex) => {
        return <>{row.ERROR_MESSAGE?.substr(0,100)}{row.ERROR_MESSAGE?.length > 100 ? "...": ""}</>;
      },
      headerAlign: 'center',
    },
    {
      dataField: "EXPORT_NAME",
      text: "Export Name",
      sort: true,
      headerAlign: 'center',
    },
    {
      dataField: "TOTAL_RECORD",
      text: "Total Record",
      sort: true,
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: "DATE_TIME_START",
      text: "Date Start",
      sort: true,
      formatter: (cell, row, rowIndex) => {
        return <>{ToDateTimeText(row.DATE_TIME_START)}</>;
      },
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: "DATE_TIME_END",
      text: "Date End",
      sort: true,
      formatter: (cell, row, rowIndex) => {
        return <>{ToDateTimeText(row.DATE_TIME_END)}</>;
      },
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: "USER_NAME",
      text: "Create By",
      sort: true,
      headerAlign: 'center',
      align: 'center',
    },
  ];
  return columns;
};
export const getDetailUpload = () => {
  const columns = [
    {
      dataField: "ColumnName",
      text: "Column Name",
      sort: true,
    },
    {
      dataField: "Encrypt",
      text: "Encrypt Type",
      sort: true,
    },

  ];
  return columns;
};
